import React from "react";
import { useGame } from "context/GameContext";
import HeaderResources from "./HeaderResources";
import Locations from "model/locations";
import HeaderDiv from "./Header.style";
import HeaderButton from "./HeaderButton.style";

const Header = () => {
  const { gameState, setGameState } = useGame();
  const { party, calendar, location } = gameState;

  const locations = Object.keys(Locations).map((key) => {
    const loc = Locations[key];
    return {
      ...loc,
      key,
      visible: loc.isVisible(party.phase, loc.index, party.city),
      name: loc.name(party.city),
      selected: loc.selected(location, loc.index, party.city),
    };
  });

  if (!locations) return null;

  const handleClick = (clickTarget) => {
    setGameState((prev) => ({ ...prev, location: clickTarget }));
  };

  return (
    <HeaderDiv>
      <div>
        {locations.map((loc) => {
          return (
            loc.visible && (
              <HeaderButton
                selected={!!loc.selected}
                key={loc.key}
                id={`location_${loc.key.toLowerCase()}`}
                onClick={() => handleClick(loc.clickTarget(party.city))}
              >
                {loc.name}
              </HeaderButton>
            )
          );
        })}
      </div>

      <HeaderResources {...party} calendar={calendar} />
    </HeaderDiv>
  );
};

export default Header;
